import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  slider: "[data-values]",
};

const initValues = (container) => {
  Swiper.use([Pagination, Navigation]);

  return new Swiper(container.querySelector(".swiper"), {
    enabled: true,
    slidesPerView: "auto",
    spaceBetween: 16,

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
      clickable: true,
      bulletActiveClass: "active",
      bulletClass: "bullet",
    },

    navigation: {
      nextEl: container.querySelector("[data-swiper-navigation-next]"),
      prevEl: container.querySelector("[data-swiper-navigation-prev]"),
    },

    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
    },
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const containers = document.querySelectorAll(selectors.slider);

    containers?.forEach(initValues);
  },
  {
    once: true,
  }
);
